import { render, staticRenderFns } from "./repairItem.vue?vue&type=template&id=3ccf0c4e&scoped=true&"
import script from "./repairItem.vue?vue&type=script&lang=js&"
export * from "./repairItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf0c4e",
  null
  
)

export default component.exports